import {
  InvoiceStatus,
  InvoiceType,
  RecipientType,
  Language,
  DiscountType,
  TransactionType
} from './types.js';

export const AVAILABLE_TAXES = [
  { id: 'vat_20', name: 'VAT', rate: 20 },
  { id: 'vat_7', name: 'VAT', rate: 7 },
  { id: 'no_vat', name: 'Without VAT', rate: 0 },
];

export const INVOICE_TYPE_ABBREVIATIONS = {
  [InvoiceType.STANDARD]: 'STD',
  [InvoiceType.PROFORMA]: 'PRF',
  [InvoiceType.CREDIT_NOTE]: 'CRN',
  [InvoiceType.RECURRING]: 'REC',
  [InvoiceType.DEBIT_NOTE]: 'DBN',
};

export const API_TO_UI_TYPE = Object.fromEntries(
    Object.entries(INVOICE_TYPE_ABBREVIATIONS)
        .map(([ui, api]) => [api, ui])
)

export const BILL_TYPE_ID_TO_CODE = {
  1: 'STD',
  2: 'PRF',
  3: 'CRN',
  4: 'REC',
  5: 'DBN'
}

export const BILL_TYPE_CODE_TO_ID = {
  STD: 1,
  PRF: 2,
  CRN: 3,
  REC: 4,
  DBN: 5
}

export const getInvoiceTypeLabel = (type, t) => {
  switch (type) {
    case InvoiceType.STANDARD:
      return t('invoices.type_standard_title')

    case InvoiceType.PROFORMA:
      return t('invoices.type_proforma_title')

    case InvoiceType.CREDIT_NOTE:
      return t('invoices.type_credit_note_title')

    case InvoiceType.RECURRING:
      return t('invoices.type_recurring_title')

    case InvoiceType.DEBIT_NOTE:
      return t('invoices.type_debit_note_title')

    default:
      return type
  }
}

export const INITIAL_INVOICE = {
  number: '',
  status: InvoiceStatus.DRAFT,
  date: new Date().toISOString().split('T')[0],
  dueDate: new Date(Date.now() + 7 * 864e5).toISOString().split('T')[0],
  currency: 'UAH',
  type: InvoiceType.STANDARD,

  senderName: '',
  senderDetails: '',


  recipient: {
    type: RecipientType.INDIVIDUAL,
    person: {
      firstName: '',
      lastName: '',
      phone: '',
      email: '',
    },
    legal: {
      name: '',
      EDRPOU: '',
      IBAN: ''
    }
  },

  items: [
    {
      id: 'init_item',
      name: '',
      code: '',
      quantity: 1,
      unit: 'pcs',
      price: 0,
      taxes: [AVAILABLE_TAXES[0]],
      discount: { type: DiscountType.PERCENTAGE, value: 0 }
    }
  ],

  paymentPurpose: '',
  partialPayment: false,
  note: ''
};
